import { render, staticRenderFns } from "./MobileDeviceRegistrySettings.vue?vue&type=template&id=65019c9c&scoped=true&"
import script from "./MobileDeviceRegistrySettings.vue?vue&type=script&lang=js&"
export * from "./MobileDeviceRegistrySettings.vue?vue&type=script&lang=js&"
import style0 from "./MobileDeviceRegistrySettings.vue?vue&type=style&index=0&id=65019c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65019c9c",
  null
  
)

export default component.exports